// libs
import React, { PropsWithChildren, ReactNode } from 'react'

// interfaces / constants
import { CLASS_PREFIX } from 'src/constants/'
import 'src/components/profiles_list/profiles_list.scss'
import ProfileListItem from './profile_list_item'
import { ActorProfilePreviewFragmentFragment } from '@lopo-tech/lopo-api'

type ProfilesListProps<T extends ActorProfilePreviewFragmentFragment> =
  PropsWithChildren<{
    profiles: T[];
    onVisibleChange?: (id: string, inView: boolean) => void;
  }>;

const cls: string = `${CLASS_PREFIX}profiles-list`

type IRenderProps<T> = {
  items: T[];
  renderItem: (item: T, onVisibleChange?: (id: string, inView: boolean) => void) => ReactNode;
  keyExtractor?: (item: T, index: number) => React.Key;
  onVisibleChange?: (id: string, inView: boolean) => void;
};

export const CustomRenderProfileList = <T, >({
  items,
  renderItem,
  keyExtractor,
  onVisibleChange
}: IRenderProps<T>) => {
  return (
    <div className={cls}>
      <div className={`${cls}__profiles-wrapper`}>
        {items.map((item, index) => (
          <React.Fragment key={keyExtractor?.(item, index) ?? index}>
            {renderItem(item, onVisibleChange)}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

const renderProfileListItem = (
  profile: ActorProfilePreviewFragmentFragment,
  onVisibleChange?: (id: string, inView: boolean) => void
) => <ProfileListItem profile={profile} onVisibleChange={onVisibleChange} />

export const ProfilesList = <T extends ActorProfilePreviewFragmentFragment>({
  profiles,
  onVisibleChange
}: ProfilesListProps<T>) => {
  return (
    <CustomRenderProfileList
      items={profiles}
      keyExtractor={(profile) => profile.id}
      renderItem={renderProfileListItem}
      onVisibleChange={onVisibleChange}
    />
  )
}
